import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { IGetErrorCategoriesResponse } from '../interfaces/error/IGetErrorCategoriesResponse';
import { IUpdateErrorCategoryTranslationCommand } from '../interfaces/error/IUpdateErrorCategoryTranslationCommand';
import { IBaseCommandResult } from '../interfaces/results/IBaseCommandResult';

@Injectable({
  providedIn: 'root'
})
export class ErrorCategoryService {

  constructor(private apiService: APIService) { }

  public getAllCategories() {
    return this.apiService.MakeGetRequest<IGetErrorCategoriesResponse>('error-categories');
  }

  public updateCategoryTranslation(categoryId: string, command: IUpdateErrorCategoryTranslationCommand) {
    return this.apiService.MakePutRequest<IBaseCommandResult>(`error-categories/${categoryId}/translations`, command);
  }
}
